import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { orderAndQuoteSettingsPageQueryOptions } from "~/app/api/pageData/orderAndQuoteSettingsPageQuery";
import type { OrderAndQuoteSettingsPageInitialData } from "~/app/api/pageData/orderAndQuoteSettingsPageInitialData";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";
import { createOrderQuoteNotificationsPage } from "~/pages/OrderQuoteNotificationsPage/OrderQuoteNotificationsPage";

const ORDER_AND_QUOTE_SETTINGS_PATH = "/my-account/orderAndQuoteSettings";

function OrderAndQuoteSettingsRoute() {
  const result = useLoaderData({
    from: ORDER_AND_QUOTE_SETTINGS_PATH,
  }) as PageInitialData<OrderAndQuoteSettingsPageInitialData>;
  const shellProps = useStorefrontShellProps();

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      {createOrderQuoteNotificationsPage()}
    </StorefrontShellFrame>
  );
}

export async function loadOrderAndQuoteSettingsPageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(orderAndQuoteSettingsPageQueryOptions());

  return unwrapPageInitialData(result);
}

export const orderAndQuoteSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: ORDER_AND_QUOTE_SETTINGS_PATH,
  loader: async ({ context }) => loadOrderAndQuoteSettingsPageData(context),
  component: OrderAndQuoteSettingsRoute,
});
